export default __webpack_public_path__ + "static/media/publicInstitutionRecruitment.1cf44f8d.svg";